// extracted by mini-css-extract-plugin
export default {"languageButton":"GlobalLanguageToggle_languageButton__XP7G-"};